<template>
    <div class="container">
        <top></top>

        <list></list>

        <div class="major">
            <div class="content">
                <img src="../assets/img-Partner/1.jpg" alt="">
            </div>

            <div class="main">
                <div class="cooperative-partner">
                    <h2>
                        <span v-t="'cooperative_partner'"></span>
                    </h2>
                    <div class="cooperative-partner-content">
                        <ul>
                            <li>
                                <a href="https://www.qualcomm.cn/snapdragon" target="_blank">
                                    <img src="../assets/img-Partner/HighPass.jpg" alt="">
                                </a>
                                <div>
                                    <span v-t="'high_pass_span'"></span>
                                    <p v-t="'high_pass_p'"></p>
                                </div>
                            </li>
                            <li>
                                <a href="https://www.mi.com/?masid=2701.0074" target="_blank">
                                    <img src="../assets/img-Partner/millet.jpg" alt="">
                                </a>
                                <div>
                                    <span v-t="'millet_span'"></span>
                                    <p v-t="'millet_p'"></p>
                                </div>
                            </li>
                            <li>
                                <a href="https://www.baidu.com" target="_blank">
                                    <img src="../assets/img-Partner/Baidu.jpg" alt="">
                                </a>
                                <div>
                                    <span v-t="'Baidu_span'"></span>
                                    <p v-t="'Baidu_p'"></p>
                                </div>
                            </li>
                            <li>
                                <a href="http://www.googoltechdg.com" target="_blank">
                                    <img src="../assets/img-Partner/SolidHeight.jpg" alt="">
                                </a>
                                <div>
                                    <span v-t="'Solid_height_span'"></span>
                                    <p v-t="'Solid_height_p'"></p>
                                </div>
                            </li>
                            <li>
                                <a href="http://www.chinaunicom.com.cn" target="_blank">
                                    <img src="../assets/img-Partner/Unicom.jpg" alt="">
                                </a>
                                <div>
                                    <span v-t="'China_Unicom_span'"></span>
                                    <p v-t="'China_Unicom_p'"></p>
                                </div>
                            </li>
                            <li>
                                <a href="http://www.chinatelecom.com.cn" target="_blank">
                                    <img src="../assets/img-Partner/telecom.jpg" alt="">
                                </a>
                                <div>
                                    <span v-t="'China_Telecom_span'"></span>
                                    <p v-t="'China_Telecom_p'"></p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <bottom></bottom>
    </div>
</template>

<script>
    import top from "../components/common/Head";
    import list from "../components/common/Nav";
    import bottom from "../components/common/Foot";

    export default {
        name: "Partner",
        components: {
            top,
            list,
            bottom,
        },
    }
</script>

<style scoped>
    .content img{
        width: 100%;
        height: 100%;
    }
    .cooperative-partner{
        width: 1000px;
        display: flex;
        padding: 30px 0;
        flex-direction: column;
        margin-top: 20px;
    }
    .cooperative-partner h2{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .cooperative-partner h2 span{
        border-bottom: 2px solid #c7000b;
        padding-bottom: 10px;
    }
    .cooperative-partner-content{
       padding: 10px 0;
    }
    .cooperative-partner-content ul{
        display: flex;
        flex-direction: column;
    }
    .cooperative-partner-content ul li{
        display: flex;
        margin: 40px 0;
    }
    .cooperative-partner-content ul li img{
        width: 400px;
        height: 260px;
        display: block;
    }
    .cooperative-partner-content ul li div{
        text-align: left;
        margin-left: 30px;
        padding: 0;
    }
    .cooperative-partner-content ul li div span{
        font-size: 22px;
        font-weight: bold;
    }
    .cooperative-partner-content ul li div p{
        word-break: break-all;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 8;
        overflow: hidden;
        text-indent: 2em;
        font-size: 16px;
        line-height: 25px;
    }
</style>